import { createTheme } from '@mui/material/styles'

import palette from './palette'
import typography from './typography'
import components from './components'
import shape from './shape'
import breakpoints from './breakpoints'
import spacing from './spacing'

const theme = createTheme({
  palette,
  typography,
  components,
  shape,
  breakpoints,
  spacing
});

export default theme;
export { palette, typography, components, shape, breakpoints, spacing };
